import { useState } from 'react'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appAllGetRequestedHubs } from '../../store/requestedhub'
import { useDispatch } from 'react-redux'
import {
	communityCasteRequestedColumns,
	switchCommunityRequestedColumns,
} from '../../config/exportColumns/requestedHubExportColumns'

function HubRequested() {
	const dispatch = useDispatch()
	const [activeTab, setActiveTab] = useState('communitycasterequsted')

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between align-items-center">
					<div>Community & Caste Requested</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetRequestedHubs({
									...params,
									hubswitchrequested: activeTab === 'requestedcommunity',
									loading: false,
								}),
							)
						}
						columns={
							activeTab === 'requestedcommunity'
								? switchCommunityRequestedColumns
								: communityCasteRequestedColumns
						}
						fileName={
							activeTab === 'requestedcommunity'
								? 'Requested_Community_Switch'
								: 'Community_Caste_Requested'
						}
						sheetName="Requests"
						buttonText={
							activeTab === 'requestedcommunity'
								? 'Export Requested Community Switch'
								: 'Export Community Caste Requested'
						}
					/>
				</div>

				<TableFilter activeTab={activeTab} setActiveTab={setActiveTab} />
			</div>
		</>
	)
}

export default HubRequested
